import React  from 'react';
import { useSelector } from 'react-redux';
import MarketPlacePolicyBasicInfoComponent from './market-place-policy-basic-info.component';
import MarketPlacePolicyDetailsComponent from './market-place-details.component';
import { selectListItems } from '../../../../../redux/library/selector';
import IncludeComponent from '../../../../../common/components/common/include.component';
import ExcludeComponent from '../../../../../common/components/common/exclude.component';
import MediaInfoComponent from '../../../../../common/components/common/media-info.component';
import TabContainer from '../../../../../common/components/tab/containers/tab.containers';


export const MarketPlacePolicyComponent = ({changeImage,
  mediaFiles,
  onFormChange,
  onFormItemChange,
  onFormSubmit,
  selectedProgram,
  entityTypes,
  vendors,
  products,
  id,
  onInnerFormChange,
  organizationUnits,
  setSelectedPolicyCollections,
  allTags,
  customers,
  fetchMappedCollections,
  columnDefs,
  onDelete,
  rowData,
back}: any) => {
  const libraryData = useSelector(selectListItems)
  const tabItems=[
    {
        id:1,
        title:'MarketPlace Policy Basic Info',
        component:<MarketPlacePolicyBasicInfoComponent 
        onFormChange={onFormChange}
        selectedProgram={selectedProgram}
        entityTypes={entityTypes}
        organizationUnits={organizationUnits}
        />,
    isVisible:true,
    },
    {
      id:2,
      title:'Market Place  Details',
      component: <MarketPlacePolicyDetailsComponent
      id={id}
          columnDefs={columnDefs}
          rowData={rowData}          
          onDelete={onDelete}
          fetchMappedCollections={fetchMappedCollections}
          onInnerFormChange={onInnerFormChange}
          entityTypes={entityTypes}
          // categories={categories}
          products={products}
          vendors={vendors}
          selectedPolicyCollections={selectedProgram}
          setSelectedPolicyCollections={setSelectedPolicyCollections}
          
  />,
  isVisible:id>0?true:false,
  },
  {
    id: 3,
    title: 'Include Entity',
    component: <IncludeComponent
      allTags={allTags}
      isSaleChannel={true}
      isCustomerTag={true}
      isCustomer={true}
      isStore={true}
      isWarehouse={true}
      isState={true}
      isCountry={true}
      customers={customers}
      handleInnerFormChange={onInnerFormChange}
      selectedInclude={selectedProgram}
    />,
    isVisible: true,
  },

  {
    id: 4,
    title: 'Exclude Entity',
    component: <ExcludeComponent
      isSaleChannel={true}
      isCustomerTag={true}
      isCustomer={true}
      isStore={true}
      isWarehouse={true}
      isState={true}
      isCountry={true}
      customers={customers}
      allTags={allTags}
      handleInnerFormChange={onInnerFormChange}
      selectedExclude={selectedProgram}
    />,
    isVisible: true,
  },
    {
      id:5,
      title:'Media',
      component:<MediaInfoComponent
      changeImage={changeImage}
      fileTypes={libraryData?.result?.FileType}
      onFormItemChange={onFormItemChange}
      mediaFiles={mediaFiles}
      />,
  isVisible:true,
  },
    
  ]
    
  return (
    <div className="flex flex-col items-center w-full px-5 h-[620px] overflow-auto">
       
     
      <TabContainer tabItems={tabItems} />
   
      <div className='flex w-full justify-end items-end'>
        <button
              onClick={back}
              type='button'
              className="m-2 bg-blue-700 text-white rounded font-medium px-4 py-3 "
             >
              Back
             </button>
             <button
            className="m-2 bg-blue-700 text-white rounded font-medium px-4 py-3 "
              onClick={onFormSubmit}
            
              type="submit"
          >
            Save
          </button>
        </div>
       </div>
  )
}
export default MarketPlacePolicyComponent;
